<script lang="ts">
  import ButaneImage from '$lib/components/ButaneImage.svelte'
  const values = [
    {
      id: 1,
      title: 'Embracing Innovation',
      desc: "We foster a culture of creativity and forward-thinking, encouraging our team and community to explore bold ideas and push the boundaries of what's possible.",
    },
    {
      id: 2,
      title: 'Community Driven',
      desc: 'At Butane, we believe in the power of community-driven initiatives, where users actively participate in shaping the future of our platform.',
    },
    {
      id: 3,
      title: 'Developer Friendly',
      desc: 'Butane prioritizes ease of use for developers, promoting interoperability and accessibility to encourage seamless integration and innovation on our platform.',
    },
    {
      id: 4,
      title: 'True Decentralisation',
      desc: 'Butane champions decentralization and self-sovereignty, providing users with autonomy and independence over their financial assets.',
    },
  ]
</script>

<div class="mx-auto max-w-screen-xl-desktop">
  <section
    class="relative mx-auto flex max-w-screen-xl-desktop flex-col justify-between overflow-hidden rounded-lg bg-[#24CAFF] text-black lg-desktop:mx-8"
  >
    <div class="relative flex h-[175px] w-full items-center justify-center md:h-[250px]">
      <h2
        class="heading absolute top-[40%] z-[2] font-cirka text-[15vw] font-medium uppercase text-black xl-mobile:top-[70%] xl-mobile:text-[80px] xs-tablet:text-[95px] md:text-[145px] sm-desktop:top-[100%] sm-desktop:text-[180px] lg-desktop:text-[190px]"
      >
        Values
      </h2>
      <div class="img-container absolute top-[0%] xs-tablet:top-[-30%] lg-desktop:top-[0%]">
        <ButaneImage
          src="values_ribbon.png"
          layout="fullWidth"
          alt="img"
          class="h-[260px] w-[260px] rotate-[300deg] scale-[1.8] object-cover sm:h-[400px] sm:w-[400px] md:h-[550px] md:w-[550px] lg:h-[650px] lg:w-[650px] lg:scale-[1.7] xl:h-[750px] xl:w-[750px] 2xl:rotate-[310deg] 2xl:scale-[2]"
        />
      </div>
    </div>
    <ul
      class="relative z-[1] mt-6 space-y-6 px-6 pb-12 xl-mobile:mt-20 xs-tablet:mt-32 md:grid md:grid-cols-2 md:space-y-0 xl-tablet:mt-44 sm-desktop:mt-56 xl:mt-80 xl:grid-cols-4 xl:border-t xl:border-black xl:pb-0"
    >
      {#each values as { id, title, desc }}
        <li class="space-y-8 border-t border-black py-4 md:space-y-8 md:p-4 xl:space-y-32 xl:border-t-0 xl:pt-12">
          <div class="flex w-[40px] items-center justify-center rounded-full bg-black px-5 py-0.5">
            <p class="text-[#24CAFF]">0{id}</p>
          </div>
          <div class="xl:space-y-6 xl:pb-16">
            <h3
              class="font-cirka text-3xl xl:pr-8 xl:text-[42px] xl:leading-[45px] lg-desktop:text-[50px] lg-desktop:leading-[55px]"
            >
              {title}
            </h3>
            <p class="mt-3 font-graphik leading-6 lg:text-[16px] xl:w-[95%] lg-desktop:w-[90%]">{desc}</p>
          </div>
        </li>
      {/each}
    </ul>
  </section>
</div>

<style lang="postcss">
  @media (min-width: 768px) {
    ul > :global(*) {
      border-right: 1px solid black;
    }

    ul > :global(*:nth-child(2n)) {
      border-right: none;
    }

    ul > :global(*:nth-last-child(-n + 2)) {
      border-bottom: none;
    }
  }

  @media (min-width: 1280px) {
    ul > li {
      border-right: 1px solid black;
    }

    ul > li:last-child {
      border-right: none;
    }
  }
</style>
